import styled from 'styled-components'

export const StyledContainer = styled.div`
  margin-left: 25px;
  margin-right: 25px;
`
